import { render, staticRenderFns } from "./_reviewSection.vue?vue&type=template&id=17084ce0&scoped=true&lang=pug&"
import script from "./_reviewSection.vue?vue&type=script&lang=js&"
export * from "./_reviewSection.vue?vue&type=script&lang=js&"
import style0 from "./_reviewSection.vue?vue&type=style&index=0&id=17084ce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17084ce0",
  null
  
)

export default component.exports